/**
 * Cart Totals Calculator EU - Complete JS Version
 * Replicates ALL logic from cart-totals-summary-eu-view.liquid
 * All calculations performed in JavaScript
 */

/**
 * Cart Totals Calculator EU - Complete JS Version
 * Replicates ALL logic from cart-totals-summary-eu-view.liquid
 * All calculations performed in JavaScript
 */

document.addEventListener('DOMContentLoaded', () => {
  const _euCalcLog = typeof window.createLogger === 'function'
    ? window.createLogger('CartTotalsCalculatorEU')
    : { log: () => {}, warn: () => {}, error: () => {} };

  _euCalcLog.log('DOMContentLoaded fired');
  _euCalcLog.log('window.subscribe:', typeof window.subscribe, 'window.PUB_SUB_EVENTS:', typeof window.PUB_SUB_EVENTS);

  if (!window.CartItemsData) {
    _euCalcLog.warn('CartItemsData not found');
    return;
  }

  _euCalcLog.log('CartItemsData found:', window.CartItemsData);

  let cartData = window.CartItemsData;
  const shippingCountries = cartData.shippingCountries;
  const dutyData = cartData.dutyData;
  const resolvedLocale = 'en-IE';
  const currency = 'EUR';

  // Resolve the active destination country.
  // initialVatDivisor uses the server-rendered country (what Shopify priced with).
  // currentCountryCode starts from localStorage if available so that a
  // previous shipping-calculator selection persists across page reloads.
  function resolveInitialCountry(serverCountry) {
    if (window.location.pathname.includes('/en-eu')) {
      try {
        var lsCountry = localStorage.getItem('n4y_eu_country');
        if (lsCountry && lsCountry.length === 2) {
          _euCalcLog.log('Initial country from localStorage:', lsCountry.toUpperCase());
          return lsCountry.toUpperCase();
        }
      } catch (_) {}
    }
    return serverCountry;
  }

  let currentCountryCode = resolveInitialCountry(cartData.destination);
  let currentShippingRateWithVAT = 0; // in cents

  let isB2BCustomer = false;

  _euCalcLog.log('Current country (resolved):', currentCountryCode, '| Server country:', cartData.destination);

  // Calculate cart total without VAT ONCE at initialization based on initial country.
  // Uses cartData.destination (server-rendered VAT context) NOT the localStorage
  // override — the prices on this page were rendered by Shopify for that country.
  let initialVatRate = getVatRateForInitialCountry(cartData.destination);
  let initialVatDivisor = 1.0 + initialVatRate;
  let cartTotalWithVatCents = cartData.cartTotalWithVAT;
  let cartTotalWithoutVatCents = cartTotalWithVatCents / initialVatDivisor;
  window.cartTotalEuroVatExcl = cartTotalWithoutVatCents / 100;

  _euCalcLog.log('Initialized with cart data:', cartData);
  _euCalcLog.log('Initial VAT rate:', initialVatRate);
  _euCalcLog.log('Cart Total WITH VAT (cents):', cartTotalWithVatCents);
  _euCalcLog.log('Cart Total WITHOUT VAT (cents):', cartTotalWithoutVatCents);

  /**
   * Update cart data from Shopify's cart response
   * CRITICAL: Do NOT recalculate initialVatRate - it must remain constant
   */
  function updateCartData(shopifyCart) {
    _euCalcLog.log('Updating cart data from Shopify response:', shopifyCart);

    // Update cart total with VAT
    cartTotalWithVatCents = shopifyCart.total_price || 0;

    // CRITICAL FIX: Use the INITIAL VAT rate (set once at page load)
    // DO NOT recalculate initialVatRate here - it must stay constant!
    // The initial VAT rate represents the VAT already baked into Shopify prices
    cartTotalWithoutVatCents = cartTotalWithVatCents / initialVatDivisor;

    _euCalcLog.log('Using INITIAL VAT divisor:', initialVatDivisor, '(rate:', initialVatRate, ')');

    // Update items data
    if (shopifyCart.items && Array.isArray(shopifyCart.items)) {
      cartData.items = shopifyCart.items.map((item) => {
        // Find matching item in original cartData to get metafield data
        const originalItem = cartData.items.find((orig) => orig.id === item.id) || {};

        return {
          id: item.id,
          title: item.title,
          productTitle: item.product_title,
          variantTitle: item.variant_title,
          quantity: item.quantity,
          finalLinePrice: item.final_line_price,
          sku: item.sku,
          countryOfOrigin: originalItem.countryOfOrigin || null,
          hsCode: originalItem.hsCode || null,
          finalPrice: item.final_price
        };
      });
    }

    _euCalcLog.log('Updated cart total WITH VAT:', cartTotalWithVatCents);
    _euCalcLog.log('Updated cart total WITHOUT VAT:', cartTotalWithoutVatCents);
    _euCalcLog.log('Updated items:', cartData.items);
  }

  /**
   * Get VAT rate for initial country (used only once at initialization)
   */
  function getVatRateForInitialCountry(countryCode) {
    if (typeof window.getVatRate === 'function') {
      return window.getVatRate(countryCode);
    }
    _euCalcLog.warn('window.getVatRate not found, defaulting to 0');
    return 0;
  }

  /**
   * Get VAT rate for destination country
   * Uses global utility function from vat-utils.js
   */
  function getVatRate(countryCode) {
    if (typeof window.getVatRate === 'function') {
      const rate = window.getVatRate(countryCode);
      _euCalcLog.log(`VAT rate for ${countryCode}:`, rate);
      return rate;
    }
    _euCalcLog.warn('window.getVatRate not found, defaulting to 0');
    return 0;
  }

  /**
   * Get admin fee without VAT for destination country (in cents)
   * Matches Liquid: admin_fee_decimal | times: 100.0
   */
  function getAdminFeeWithoutVat(countryCode) {
    if (!shippingCountries || !shippingCountries[countryCode]) {
      _euCalcLog.warn(`No admin fee found for ${countryCode}, defaulting to 0`);
      return 0;
    }
    const adminFeeDecimal = parseFloat(shippingCountries[countryCode].admin_fee_without_vat) || 0;
    return adminFeeDecimal * 100; // Convert to cents
  }

  /**
   * Get duty rate from mapping
   * Matches Liquid logic:
   * {% assign duty_rate_decimal = duty_data[origin][destination][hs_code] %}
   * {% if duty_rate != 1 %}
   *   {% assign duty_rate = duty_rate_decimal | divided_by: 100.0 %}
   *   {% assign duty_rate = duty_rate | plus: 1.0 %}
   * {% endif %}
   */
  function getDutyRate(countryOfOrigin, destination, hsCode) {
    if (!dutyData || !countryOfOrigin || !destination || !hsCode) {
      return 1.0; // No duty
    }

    const dutyRateDecimal = dutyData[countryOfOrigin]?.[destination]?.[hsCode];
    if (dutyRateDecimal === undefined || dutyRateDecimal === null) {
      return 1.0; // No duty found
    }

    // Match Liquid logic exactly
    let dutyRate = dutyRateDecimal;
    if (dutyRate !== 1) {
      dutyRate = dutyRateDecimal / 100.0;
      dutyRate = dutyRate + 1.0;
    }

    return dutyRate;
  }

  /**
   * Get raw duty rate percentage for display
   * Matches Liquid: {{ duty_rate_decimal }}%
   */
  function getDutyRatePercent(countryOfOrigin, destination, hsCode) {
    if (!dutyData || !countryOfOrigin || !destination || !hsCode) {
      return 0;
    }

    const dutyRateDecimal = dutyData[countryOfOrigin]?.[destination]?.[hsCode];
    return dutyRateDecimal || 0;
  }

  /**
   * Format money
   * Uses global utility function from money-utils.js
   */
  function formatMoneyAmount(amountCents) {
    if (typeof window.formatMoney === 'function') {
      return window.formatMoney(amountCents, { locale: resolvedLocale, currency: currency, isCents: true });
    }
    // Fallback
    const amountDecimal = amountCents / 100;
    return new Intl.NumberFormat(resolvedLocale, {
      style: 'currency',
      currency: currency,
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(amountDecimal);
  }

  /**
   * Escape HTML for safe insertion
   */
  function escapeHtml(text) {
    const div = document.createElement('div');
    div.textContent = text;
    return div.innerHTML;
  }

  /**
   * Calculate all totals
   * Exact replication of Liquid logic from cart-totals-summary-eu-view.liquid
   */
  function calculate() {
    try {
      _euCalcLog.log('Calculating totals for country:', currentCountryCode);

      // Step 1: Duty only applies to B2B customers — B2C customers never pay import duty
      const isAboveIossThreshold = isB2BCustomer;

      const vatRate = getVatRate(currentCountryCode);
      const vatDivisor = 1.0 + vatRate;

      _euCalcLog.log('Duty eligibility — isB2BCustomer:', isB2BCustomer, 'dutyApplies:', isAboveIossThreshold);
      _euCalcLog.log('Selected Country VAT Rate:', vatRate, 'VAT Divisor:', vatDivisor);
      _euCalcLog.log('Initial Country VAT Rate:', initialVatRate, 'Initial VAT Divisor:', initialVatDivisor);

      // Matches: {% assign admin_fee_without_vat = admin_fee_decimal | times: 100.0 %}
      let adminFeeWithoutVatCents = getAdminFeeWithoutVat(currentCountryCode);
      if (!isB2BCustomer) {
        // No courier admin fee for B2C customers
        adminFeeWithoutVatCents = 0;
      }

      // Shipping rate in cents
      // let shippingRateCentsWithoutVAT = currentShippingRateWithVAT;
      const shippingRateCentsWithoutVAT = currentShippingRateWithVAT / vatDivisor;

      // NOTE: cartTotalWithoutVatCents is calculated ONCE at initialization
      // It should NOT be recalculated here based on new country VAT rate
      _euCalcLog.log('Using pre-calculated Cart Total WITHOUT VAT:', cartTotalWithoutVatCents);

      // Step 3: Initialize accumulators
      // Matches Liquid variables
      let cartTotalWithDutyCents = 0.0;
      let totalItemsDutyCents = 0.0;
      let cartTotalDutyWeitage = 0.0;
      const dutyItemsHtml = [];

      // Step 4: Loop through items
      // Matches: {% for item in cart.items %}
      cartData.items.forEach((item) => {
        // Use API data if available, otherwise fallback to metafield data
        let origin = item.countryOfOrigin;
        let hsCode = item.hsCode;

        // Check if API stock data is available for this item's SKU
        if (window.CartApiStockData && window.CartApiStockData.products && item.sku) {
          const apiData = window.CartApiStockData.products[item.sku];
          if (apiData) {
            // Prefer API data over metafield data
            if (apiData.country_of_origin) {
              origin = apiData.country_of_origin;
              _euCalcLog.log(`Using API country_of_origin for SKU ${item.sku}: ${origin}`);
            }
            if (apiData.hs_code) {
              hsCode = apiData.hs_code;
              _euCalcLog.log(`Using API hs_code for SKU ${item.sku}: ${hsCode}`);
            }
          } else {
            _euCalcLog.log(`No API data found for SKU ${item.sku}, using metafield data`);
          }
        } else if (item.sku) {
          _euCalcLog.log(`API stock data not available for SKU ${item.sku}, using metafield data`);
        }

        // Matches: {% assign duty_rate_decimal = 1.0 %}...
        const dutyRate = getDutyRate(origin, currentCountryCode, hsCode);
        const dutyRateDecimal = getDutyRatePercent(origin, currentCountryCode, hsCode);

        // Matches: {% assign item_price_with_vat = item.final_line_price %}
        const itemPriceWithVatCents = item.finalLinePrice;

        // CRITICAL FIX: Use initialVatDivisor (origin country VAT) not vatDivisor (destination country VAT)
        // Shopify prices already include origin country VAT, so we must remove it using the same rate
        // Matches: {% assign item_price_without_vat = item_price_with_vat | divided_by: vat_divisor %}
        const itemPriceWithoutVatCents = itemPriceWithVatCents / initialVatDivisor;

        // Matches: {% assign item_price_with_duty = item_price_without_vat | times: duty_rate %}
        const itemPriceWithDutyCents = itemPriceWithoutVatCents * dutyRate;

        // Matches: {% assign cart_total_with_duty = cart_total_with_duty | plus: item_price_with_duty %}
        cartTotalWithDutyCents += itemPriceWithDutyCents;

        // Matches: {% assign item_duty = item_price_with_duty | minus: item_price_without_vat %}
        const itemDutyCents = itemPriceWithDutyCents - itemPriceWithoutVatCents;

        // Matches: {% assign total_items_duty = total_items_duty | plus: item_duty %}
        totalItemsDutyCents += itemDutyCents;

        // Matches: {% assign item_fraction_of_total_basket = item_price_without_vat | divided_by: cart_total_without_vat %}
        const itemFractionOfTotalBasket = itemPriceWithoutVatCents / cartTotalWithoutVatCents;

        // Matches: {% assign item_duty_weitage = item_fraction_of_total_basket | times: duty_rate %}
        const itemDutyWeitage = itemFractionOfTotalBasket * dutyRate;

        // Matches: {% assign cart_total_duty_weitage = cart_total_duty_weitage | plus: item_duty_weitage %}
        cartTotalDutyWeitage += itemDutyWeitage;

        _euCalcLog.log(`Item: ${item.productTitle}, duty rate: ${dutyRate}, duty: ${itemDutyCents.toFixed(2)} cents`);

        // Only show duty rows when above IOSS threshold
        // Per-item duty rows removed — total is shown as a single row below courier admin fee.
      });

      // Suppress duty amounts when below IOSS threshold — set to neutral values so
      // downstream calculations remain correct without duty contribution.
      // cartTotalDutyWeitage = 1.0 means shippingWithDuty = shippingRate, shippingDuty = 0.
      const effectiveTotalItemsDutyCents = isAboveIossThreshold ? totalItemsDutyCents : 0;
      const effectiveCartTotalDutyWeitage = isAboveIossThreshold ? cartTotalDutyWeitage : 1.0;

      // Step 5: Calculate shipping duty
      // Matches: {% assign shipping_with_duty = shipping_rate | times: cart_total_duty_weitage %}
      const shippingWithDutyCents = shippingRateCentsWithoutVAT * effectiveCartTotalDutyWeitage;

      // Matches: {% assign shipping_duty = shipping_with_duty | minus: shipping_rate %}
      const shippingDutyCents = shippingWithDutyCents - shippingRateCentsWithoutVAT;

      // Step 6: Calculate all_total_without_vat
      // Matches: {% assign all_total_without_vat = cart_total_without_vat | plus: total_items_duty | plus: shipping_with_duty | plus: admin_fee_without_vat %}
      const allTotalWithoutVatCents =
        cartTotalWithoutVatCents + effectiveTotalItemsDutyCents + shippingWithDutyCents + adminFeeWithoutVatCents;

      // Step 7: Calculate VAT amount
      // Matches: {% assign vat_amount = all_total_without_vat | times: vat_rate %}
      const vatAmountCents = allTotalWithoutVatCents * vatRate;

      // Matches: {% assign total_duty = total_items_duty | plus: shipping_duty %}
      const totalDutyCents = effectiveTotalItemsDutyCents + shippingDutyCents;

      // Step 8: Calculate landed total
      // Matches: {% assign landed_total = all_total_without_vat | plus: vat_amount %}
      const landedTotalCents = allTotalWithoutVatCents + vatAmountCents;

      // Step 9: Calculate payment splits
      // Matches: {{ cart_total_without_vat | plus: shipping_rate | money }}
      const totalPayToUsCents = cartTotalWithoutVatCents + shippingRateCentsWithoutVAT;

      // Matches: {{ total_duty | plus: admin_fee_without_vat | plus: vat_amount | money }}
      const totalPayToCourierCents = totalDutyCents + adminFeeWithoutVatCents + vatAmountCents;

      _euCalcLog.log('Calculation complete:', {
        vatRate,
        cartTotalWithoutVatCents,
        totalItemsDutyCents,
        shippingDutyCents,
        allTotalWithoutVatCents,
        vatAmountCents,
        landedTotalCents,
        totalPayToUsCents,
        totalPayToCourierCents
      });

      // Step 10: Update DOM
      window.cartTotalEuroVatExcl = cartTotalWithoutVatCents / 100;
      updateElement('cart-total-without-vat-eu', formatMoneyAmount(cartTotalWithoutVatCents));
      updateElement('duty-items-container', '', true);
      updateElement('total-items-duty-amount-display', formatMoneyAmount(effectiveTotalItemsDutyCents));
      toggleElementVisibility('total-items-duty-summary', isAboveIossThreshold);
      updateElement('shipping-rate-display', formatMoneyAmount(shippingRateCentsWithoutVAT));
      toggleElementVisibility('shipping-summary', shippingRateCentsWithoutVAT > 0);
      updateElement('shipping-duty-amount-display', formatMoneyAmount(shippingDutyCents));
      toggleElementVisibility('shipping-duty-summary', shippingDutyCents > 0);
      updateElement('admin-fee-amount-display', formatMoneyAmount(adminFeeWithoutVatCents));
      updateElement('total-payable-without-vat-amount-display', formatMoneyAmount(allTotalWithoutVatCents));
      updateElement('vat-rate-display', parseFloat((vatRate * 100).toFixed(2)).toString());
      updateElement('vat-amount-display', formatMoneyAmount(vatAmountCents));
      updateElement('landed-total-amount-display', formatMoneyAmount(landedTotalCents));
      updateElement('pay-to-us-amount-display', formatMoneyAmount(totalPayToUsCents));
      updateElement('pay-to-courier-amount-display', formatMoneyAmount(totalPayToCourierCents));
      // Show/hide duty label in payment on delivery info
      var hasDutyProducts = effectiveTotalItemsDutyCents > 0;
      var dutyLabel = document.getElementById('duty-label');
      if (dutyLabel) {
        dutyLabel.style.display = hasDutyProducts ? 'inline' : 'none';
      }
      handleB2BAndB2CTotalsSummary();
    } catch (error) {
      _euCalcLog.error('Calculation error:', error);
    }
  }

  /**
   * Helper function to update DOM element
   */
  function updateElement(id, value, isHTML = false) {
    const element = document.getElementById(id);
    if (element) {
      if (isHTML) {
        element.innerHTML = value;
      } else {
        element.textContent = value;
      }
    }
  }

  /**
   * Helper function to show/hide DOM element
   */
  function toggleElementVisibility(id, shouldShow) {
    const element = document.getElementById(id);
    if (!element) {
      _euCalcLog.warn(`setElementVisibility: element with id "${id}" not found`);
      return;
    }

    // Respect reduced-motion users
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (prefersReducedMotion) {
      element.style.display = shouldShow ? '' : 'none';
      return;
    }

    // Keep original display mode for correct restore
    if (!element.dataset.n4yDisplay) {
      const computedDisplay = window.getComputedStyle(element).display;
      const fallbackDisplay = element.tagName === 'HR' ? 'block' : 'flex';
      element.dataset.n4yDisplay = computedDisplay !== 'none' ? computedDisplay : fallbackDisplay;
    }

    // Cache original vertical spacing values for smooth in/out animation
    if (!element.dataset.n4yMarginTop) {
      const computed = window.getComputedStyle(element);
      element.dataset.n4yMarginTop = computed.marginTop;
      element.dataset.n4yMarginBottom = computed.marginBottom;
      element.dataset.n4yPaddingTop = computed.paddingTop;
      element.dataset.n4yPaddingBottom = computed.paddingBottom;
    }

    const targetDisplay = element.dataset.n4yDisplay;
    const isVisible = window.getComputedStyle(element).display !== 'none' && element.getBoundingClientRect().height > 0;

    // No-op if state is already correct
    if (shouldShow === isVisible) {
      return;
    }

    const transitionValue =
      'height 0.35s cubic-bezier(0.4, 0, 0.2, 1), opacity 0.35s cubic-bezier(0.4, 0, 0.2, 1), margin 0.35s cubic-bezier(0.4, 0, 0.2, 1), padding 0.35s cubic-bezier(0.4, 0, 0.2, 1)';

    // Cancel previous end handler if a new toggle comes during animation
    if (element._n4yTransitionEndHandler) {
      element.removeEventListener('transitionend', element._n4yTransitionEndHandler);
      element._n4yTransitionEndHandler = null;
    }

    const originalMarginTop = element.dataset.n4yMarginTop;
    const originalMarginBottom = element.dataset.n4yMarginBottom;
    const originalPaddingTop = element.dataset.n4yPaddingTop;
    const originalPaddingBottom = element.dataset.n4yPaddingBottom;

    if (shouldShow) {
      element.style.display = targetDisplay;
      element.style.transition = 'none';
      element.style.overflow = 'hidden';

      // Measure final expanded height with original spacing restored
      element.style.height = 'auto';
      element.style.marginTop = originalMarginTop;
      element.style.marginBottom = originalMarginBottom;
      element.style.paddingTop = originalPaddingTop;
      element.style.paddingBottom = originalPaddingBottom;
      const targetHeight = element.scrollHeight;

      // Start collapsed state
      element.style.height = '0px';
      element.style.opacity = '0';
      element.style.marginTop = '0px';
      element.style.marginBottom = '0px';
      element.style.paddingTop = '0px';
      element.style.paddingBottom = '0px';
      element.offsetHeight;
      element.style.transition = transitionValue;

      requestAnimationFrame(() => {
        element.style.height = `${targetHeight}px`;
        element.style.opacity = '1';
        element.style.marginTop = originalMarginTop;
        element.style.marginBottom = originalMarginBottom;
        element.style.paddingTop = originalPaddingTop;
        element.style.paddingBottom = originalPaddingBottom;
      });

      const onShowEnd = (event) => {
        if (event.propertyName !== 'height') return;
        element.style.height = '';
        element.style.opacity = '';
        element.style.marginTop = originalMarginTop;
        element.style.marginBottom = originalMarginBottom;
        element.style.paddingTop = originalPaddingTop;
        element.style.paddingBottom = originalPaddingBottom;
        element.style.overflow = '';
        element.style.transition = '';
        element.removeEventListener('transitionend', onShowEnd);
        element._n4yTransitionEndHandler = null;
      };
      element._n4yTransitionEndHandler = onShowEnd;
      element.addEventListener('transitionend', onShowEnd);
    } else {
      element.style.display = targetDisplay;
      element.style.transition = 'none';
      element.style.overflow = 'hidden';
      const startHeight = element.getBoundingClientRect().height;
      element.style.height = `${startHeight}px`;
      element.style.opacity = '1';
      element.style.marginTop = originalMarginTop;
      element.style.marginBottom = originalMarginBottom;
      element.style.paddingTop = originalPaddingTop;
      element.style.paddingBottom = originalPaddingBottom;
      element.offsetHeight;
      element.style.transition = transitionValue;

      requestAnimationFrame(() => {
        element.style.height = '0px';
        element.style.opacity = '0';
        element.style.marginTop = '0px';
        element.style.marginBottom = '0px';
        element.style.paddingTop = '0px';
        element.style.paddingBottom = '0px';
      });

      const onHideEnd = (event) => {
        if (event.propertyName !== 'height') return;
        element.style.display = 'none';
        element.style.height = '';
        element.style.opacity = '';
        element.style.marginTop = originalMarginTop;
        element.style.marginBottom = originalMarginBottom;
        element.style.paddingTop = originalPaddingTop;
        element.style.paddingBottom = originalPaddingBottom;
        element.style.overflow = '';
        element.style.transition = '';
        element.removeEventListener('transitionend', onHideEnd);
        element._n4yTransitionEndHandler = null;
      };
      element._n4yTransitionEndHandler = onHideEnd;
      element.addEventListener('transitionend', onHideEnd);
    }
  }

  function handleB2BAndB2CTotalsSummary() {
    // Implement B2B and B2C specific logic here if needed
    if (isB2BCustomer) {
      _euCalcLog.log('Handling B2B customer logic');
    } else {
      _euCalcLog.log('Handling B2C customer logic');
      // Add B2C specific calculations or DOM updates here
    }
    // HOW YOU'LL PAY section wrapper
    toggleElementVisibility('how-you-pay-section', isB2BCustomer);
    // Courier admin fee
    toggleElementVisibility('admin-fee-summary', isB2BCustomer);
    // Total (Excl. VAT)
    toggleElementVisibility('total-payable-without-vat-summary', isB2BCustomer);
    // Estimated payment at checkout
    toggleElementVisibility('pay-to-us-summary', isB2BCustomer);
    // Estimated payment on delivery
    toggleElementVisibility('pay-to-courier-amount-summary', isB2BCustomer);
    // Admin fee divider
    toggleElementVisibility('admin-fee-summary-divider', isB2BCustomer);

    // Use localized strings from window.CartTranslations with fallback
    const tr = window.CartTranslations || {};
    const totalLabel = isB2BCustomer
      ? tr.total_incl_vat || 'Total (Incl. VAT)'
      : tr.total_incl_vat || 'Total (Incl. VAT)';
    updateElement('estimated-total-incl-vat', totalLabel);
  }

  // Listen for country selection events
  window.addEventListener('EU-shipping-country-selected', (event) => {
    try {
      _euCalcLog.log('Country selected:', event.detail.code);
      currentCountryCode = event.detail.code;
      currentShippingRateWithVAT = 0; // Reset shipping rate on country change
      calculate();
    } catch (err) {
      _euCalcLog.warn('Country selection error:', err);
    }
  });

  // Listen for shipping rate selection events
  window.addEventListener('EU-shipping-rate-selected', (event) => {
    try {
      const shippingRate = event.detail.shipping.price * 100; // Convert to cents
      _euCalcLog.log('Shipping rate selected:', shippingRate);
      currentShippingRateWithVAT = shippingRate;
      calculate();
    } catch (err) {
      _euCalcLog.warn('Shipping rate selection error:', err);
    }
  });

  // Listen for API stock data ready event (for HS codes and country of origin)
  window.addEventListener('cart-api-stock-data-ready', (event) => {
    try {
      _euCalcLog.log('API stock data ready, recalculating with API data:', event.detail);
      // Recalculate duty using fresh API data
      calculate();
    } catch (err) {
      _euCalcLog.warn('API stock data event error:', err);
    }
  });

  // Listen for custom cart processed event from forklift (single source of truth)
  window.addEventListener('cart-forklift-processed', (event) => {
    try {
      _euCalcLog.log('Cart processed by forklift, recalculating totals');

      // Update cart data from the event
      if (event.detail && event.detail.cartData) {
        // isB2BCustomer = true;
        updateCartData(event.detail.cartData);
        calculate();
      } else {
        _euCalcLog.warn('No cart data in forklift event');
      }
    } catch (err) {
      _euCalcLog.warn('Cart forklift processed event error:', err);
    }
  });

  _euCalcLog.log('Listening to cart-forklift-processed events (single source of truth)');

  // Listen for B2B customer creation with VAT event
  window.addEventListener('B2B-customer-created-with-VAT', (event) => {
    try {
      isB2BCustomer = event.detail.isB2BCustomer || false;
      _euCalcLog.log('B2B customer created with VAT');
      calculate();
    } catch (err) {
      _euCalcLog.warn('B2B customer creation event error:', err);
    }
  });
  // Listen for B2B customer VAT exemption checked event
  window.addEventListener('B2B-customer-VAT-exemption-checked', (event) => {
    try {
      isB2BCustomer = event.detail.isB2BCustomer || false;
      _euCalcLog.log('B2B customer VAT exemption checked');
      calculate();
    } catch (err) {
      _euCalcLog.warn('B2B customer VAT exemption event error:', err);
    }
  });

  // Initial calculation on page load
  calculate();

  // Watch for visibility changes to recalculate when container becomes visible
  const container = document.getElementById('eu-totals-cart-summary');
  _euCalcLog.log('Container element:', container);
  _euCalcLog.log('Container initial display:', container ? container.style.display : 'not found');

  if (container) {
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'attributes' && mutation.attributeName === 'style') {
          const isVisible = container.style.display !== 'none';
          _euCalcLog.log('Visibility changed, isVisible:', isVisible, 'display:', container.style.display);
          if (isVisible) {
            _euCalcLog.log('Container became visible, recalculating...');
            calculate();
          }
        }
      });
    });

    observer.observe(container, {
      attributes: true,
      attributeFilter: ['style']
    });

    _euCalcLog.log('Visibility observer attached');
  } else {
    _euCalcLog.warn('Container #eu-totals-cart-summary not found, observer not attached');
  }

  _euCalcLog.log('Module loaded');
});
